import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";
import { Link } from "react-router-dom";

export default class GroupUsers extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      items: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (!this.props.id) return;
    this.setState({ pending: true });
    let result = false;

    let items = {};
    result = await this.context.api.q("/admin/group/member", {
      id: this.props.id,
    });
    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => {
          items[item.id] = item;
        });
      }
    }

    this.setState({ pending: false, items });
  };

  renderRows() {
    return (
      <tbody>
        {Object.entries(this.state.items).map(([id, item]) => (
          <tr key={id}>
            <td width="50%">
              <Link to={`/admin/users/${item.id}/`}>{item.username}</Link>
            </td>
            <td>
              <Link to={`/admin/users/${item.id}/`}>{item.name}</Link>
            </td>
          </tr>
        ))}
      </tbody>
    );
  }
  render() {
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            {Object.keys(this.state.items).length > 0 ? (
              <div className="pt-10 mt-10 border-top">
                <h6 className="text-muted">Участники</h6>
                <table className="w-100 table">{this.renderRows()}</table>
              </div>
            ) : null}
          </Blocker>
        </div>
      </>
    );
  }
}
